import api from './api.service';

function unwrap<T>(res: unknown): T {
  const d = (res as { data?: { data?: unknown } })?.data?.data ?? (res as { data?: unknown })?.data ?? res;
  return d as T;
}

export type TreOverheadReportFilters = {
  fromDate?: string;
  toDate?: string;
  projectId?: string;
};

class TreOverheadReportsService {
  private base = '/sales/reports/tre-overhead';

  async overheadAnalysis(filters?: TreOverheadReportFilters) {
    const res = await api.get(`${this.base}/overhead-analysis`, { params: filters });
    return unwrap<unknown[]>(res);
  }

  async tradingProfitability(filters?: TreOverheadReportFilters) {
    const res = await api.get(`${this.base}/trading-profitability`, { params: filters });
    return unwrap<unknown[]>(res);
  }

  async rentalProfitability(filters?: TreOverheadReportFilters) {
    const res = await api.get(`${this.base}/rental-profitability`, { params: filters });
    return unwrap<unknown[]>(res);
  }

  async quotationMarginAnalysis(filters?: TreOverheadReportFilters) {
    const res = await api.get(`${this.base}/quotation-margin`, { params: filters });
    return unwrap<unknown[]>(res);
  }

  async projectCommercialAnalysis(filters?: TreOverheadReportFilters) {
    const res = await api.get(`${this.base}/project-commercial`, { params: filters });
    return unwrap<unknown[]>(res);
  }

  async commercialChargesAnalysis(filters?: TreOverheadReportFilters) {
    const res = await api.get(`${this.base}/commercial-charges`, { params: filters });
    return unwrap<unknown[]>(res);
  }

  async grossProfitReport(filters?: TreOverheadReportFilters) {
    const res = await api.get(`${this.base}/gross-profit`, { params: filters });
    return unwrap<unknown[]>(res);
  }
}

export default new TreOverheadReportsService();
